import {ChangeDetectionStrategy, Component, input, output, OutputEmitterRef, Signal, TemplateRef, viewChild, ViewEncapsulation} from "@angular/core";

/** Generisk nedtrekksmeny basert på material {@link Overlay#create}.
 *
 * Eksempel:
 * ```
 * <span [nedtrekksmenyTriggerFor]="enNedtrekksmeny">åpen meny</span>
 * ...
 * <nedtrekksmeny #enNedtrekksmeny>
 *     menyinnhold...
 * </nedtrekksmeny>
 * ```
 */
@Component({
    selector: 'nedtrekksmeny',
    templateUrl: 'nedtrekksmeny.html',
    styleUrl: 'nedtrekksmeny.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NedtrekksmenyKomponent implements Nedtrekksmeny {
    templateRef = viewChild.required(TemplateRef<any>);

    vedLukket = output<void>();

    bredde = input('')

    constructor() {
    }
}

export interface Nedtrekksmeny {
    templateRef: Signal<TemplateRef<any>>;
    readonly vedLukket: OutputEmitterRef<void>;
}
